<div>
  <div
    class="fill pr-xxsmall-t flex flex--row flex--top"
    [ngClass]="{ 'alert-50-bg': productChangesEnabled && changedBenefitKeys.includes(benefitWithIcon.key) }"
  >
    <div class="flex--nogrow nordic-blue-900-text ms-xsmall-r">
      <fcom-icon [name]="benefitWithIcon.icon" class="ir-xsmall"></fcom-icon>
    </div>
    <div class="flex-1">
      <div [class.heather-700-text]="isKoreanColor" class="font-body-1 medium-type nordic-blue-900-text">
        {{ benefitWithIcon.label }}
      </div>
      <div class="regular-type font-body-1 nordic-blue-900-text" *ngIf="!hasChildren">
        {{ benefitWithIcon.value }}
      </div>
    </div>
  </div>
  <div *ngIf="hasChildren">
    <ng-container *ngFor="let childBenefit of benefitWithIcon.children">
      <div
        class="fill ps-xxsmall-y flex flex--row flex--top ps-large-l ms-xsmall-y"
        [ngClass]="{ 'alert-50-bg': productChangesEnabled && changedBenefitKeys.includes(childBenefit.key) }"
        *ngIf="childBenefit.isPositive"
      >
        <div class="flex--nogrow nordic-blue-900-text ms-xsmall-r">
          <fcom-icon [name]="childBenefit.icon" class="ir-xsmall"></fcom-icon>
        </div>
        <div class="flex-1">
          <div class="font-body-1 medium-type nordic-blue-900-text">
            {{ childBenefit.label }}
          </div>
          <div class="regular-type font-body-1 nordic-blue-900-text">
            {{ childBenefit.value }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
